<template>
  <p class="auto-text" ref="p"
     :style="styles" :class="disabled ? '' : (foldFlag ? 'fold' : 'spread')"
     :title="disabled ? '' : (foldFlag ? '点击展开' : '点击收起')"
     @click="trigger" v-html="analysisContent">
  </p>
</template>

<script>
    import {faceAnalysis, atAnalysis} from "../../js/utils/textAnalysis";
    import {on, off, hasClass} from "../../js/utils/dom";
    import userCardBus from "../../js/bus/userCardBus";
    import setting from "../../config/setting";

    export default {
        name: "TextAutoContainer",
        props: {
            content: {
                type: String,
                default: ''
            },
            //限制的高度，超过这个高度就折叠
            limit: {
                type: Number,
                required: false
            }
        },
        data() {
            return {
                analysisContent: '',
                styles: {},
                foldFlag: false,
                //判断是否有必要折叠
                disabled: false,
                atDom: [],
            }
        },
        created() {
            this.analysisContent = atAnalysis(faceAnalysis(this.content), 'at');
        },
        mounted() {
            if (this.limit && this.$refs.p.offsetHeight > this.limit) {
                this.fold();
            } else {
                this.disabled = true;
            }
            let atDom = [];
            let cs = this.$refs.p.children;
            for (let i = 0; i < cs.length; i++) {
                if (hasClass(cs[i], 'at')) {
                    let item = {
                        e: cs[i], 'mouseenter': function () {
                            userCardBus.show(cs[i].getAttribute('uid'), cs[i].getBoundingClientRect())
                        }
                    };
                    on(cs[i], 'mouseenter', item.mouseenter);
                    on(cs[i], 'mouseleave', userCardBus.hide)
                    atDom.push(item);
                }
            }
            this.atDom = atDom;
        },
        methods: {
            trigger() {
                if (this.disabled) {
                    return;
                }
                //点击事件触发时如果内容有"拖蓝"则不收起或折叠
                if (!window.getSelection().isCollapsed) {
                    return;
                }
                if (this.foldFlag) {
                    this.spread()
                } else {
                    this.fold();
                }
            },
            //折叠
            fold() {
                this.styles.height = this.limit + "px";
                this.foldFlag = true;
            },
            spread() {
                this.styles = {};
                this.foldFlag = false;
            }
        },
        destroyed() {
            let a = this.atDom;
            for (let i = 0; i < a.length; i++) {
                off(a[i].e, 'mouseenter', a[i].mouseenter);
                off(a[i].e, 'mouseleave', userCardBus.hide);
            }
        }
    }
</script>

<style scoped>
  .auto-text {
    line-height: 22px;
    position: relative;
    overflow: hidden;
    word-break: break-all;
    white-space: pre-wrap;
  }

  .fold {
    cursor: pointer;
    margin-bottom: 3px;
  }

  .fold::after {
    content: '展开';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: linear-gradient(to right, transparent, rgb(124, 124, 124));
    border-radius: 0 0 2px 2px;
    line-height: 20px;
    height: 20px;
    color: white;
    text-align: right;
    padding-right: 5px;
  }

  .spread {
    cursor: pointer;
  }

  .auto-text /deep/ > img {
    vertical-align: sub;
    margin: 0 2px;
  }

  .auto-text /deep/ > img.at {
    border-radius: 4px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/view/baseComponent/TextAutoContainer.vue